module.exports = __webpack_public_path__ + "img/ngo_whatsapp_contact.827346c0.png";